import React from 'react';
import { Redirect, Route, Switch } from "react-router-dom";
import ForgotPassword from './ForgotPassword';
import Login from './Login';
import Logout from './Logout';

import SignUpFinish from './SignUpFinish';
import NhapTTUngVien from '../nhan-su/NhapTTUngVien';

export default function AuthPage() {

  return (
    <div>
      <Switch>
        <Redirect exact={true} from="/auth" to="/auth/login" />
        <Route path="/auth/login" component={Login} />

        <Route path="/auth/logout" component={Logout} />
        <Route path="/auth/khai-bao-thong-tin" component={() => {
          console.log("abc");
          
          window.location.href = 'https://ungvien.bhsgroup.vn/';
          return null;
        }} />
        <Route path="/auth/sign-up-finish" component={SignUpFinish} />
        <Route path="/auth/forgot-password" component={ForgotPassword} />
      </Switch>
    </div>
  );
}
